import React, { Fragment, useState } from 'react';
import * as Icon from 'react-bootstrap-icons';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie'
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import PageviewIcon from '@mui/icons-material/Pageview';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import PersonIcon from '@mui/icons-material/Person';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import { useDispatch } from 'react-redux';
import { resetTabState } from '../Redux/TabDucks';
import { resetAction } from '../Redux/V2/ContratoRedux';
import { ClearCookies } from '../Utilities/Utilities';
import { useNavigate } from 'react-router-dom';
import { LogoutUser } from '../Redux/UsersDucks';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';

const Menu = () => {

    const [openSubMenu, setOpenSubMenu] = useState("")
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const marginIcons = { marginLeft: "10px", marginRight: "5px" }

    const SubGeneradorContratos = [
        {
            id: 'nueva-busqueda.cliente',
            icon: <PersonSearchIcon style={marginIcons} />,
            name: 'Busqueda entrevista',
            toLink: "/home",
            onClick: () => {
                // Reseteo completo al volver a HomePageV2 desde Hoja de Atención o ContratoPage
                //   dispatch(resetTabState());               // Aca se deberia Resetear nuevo tabs
                dispatch(resetAction());                 // Resetea Redux contrato
                sessionStorage.removeItem("customerInterviewId"); // Limpiar sesión
            }
        },
        {
            id: 'nueva-busqueda.contrato',
            icon: <PersonSearchIcon style={marginIcons} />,
            name: 'Busqueda Contrato',
            toLink: "/ContractPageV2",
            onClick: () => {
                // Reseteo completo al volver a HomePageV2 desde Hoja de Atención o ContratoPage
                //   dispatch(resetTabState());               // Aca se deberia Resetear nuevo tabs
                dispatch(resetAction());                 // Resetea Redux contrato
                sessionStorage.removeItem("customerInterviewId"); // Limpiar sesión
            }
        }
        //OLD
        //{ id: 'inicio', icon: <PersonSearchIcon style={marginIcons} />, name: 'Busqueda Cliente', toLink: "/home" },
        //{ id: 'contratos', icon: <FindInPageIcon style={marginIcons} />, name: 'Busqueda Contratos', toLink: "/ContractPage" }
    ]

    const SubMenuPerfil = [
        { id: 'submenu-perfil', icon: <PersonIcon style={marginIcons} />, name: 'Antecedentes Personales', toLink: "/PerfilPage" },
        { id: 'submenu-mis-contratos', icon: <FolderSharedIcon style={marginIcons} />, name: 'Mis contratos', toLink: "/MisContratoPage" },
        /*{id:'submenu-portafolio-estado-diario',icon:<Icon.Briefcase style={marginIcons} />, name:'Estado Diario',toLink: "/portafolio/estado-diario"},*/
    ]

    /*  const SubMenuPortafolio=[
         {id:'submenu-portafolio-causa',icon:<Icon.Bank style={marginIcons} />, name:'Causas',toLink: "/portafolio/causas"},
         {id:'submenu-portafolio-novedad',icon:<Icon.Newspaper style={marginIcons} />, name:'Novedades',toLink: "/portafolio/novedades"},
         {id:'submenu-portafolio-estado-diario',icon:<Icon.Briefcase style={marginIcons} />, name:'Estado Diario',toLink: "/portafolio/estado-diario"},
     ]
 
 
     const SubGestionVentas=[
         {id:'submenu-portafolio-causa',icon:<Icon.Cash style={marginIcons} />, name:'Deudas',toLink: "/gestion_ventas/deudas"},
         {id:'submenu-portafolio-novedad',icon:<Icon.PeopleFill style={marginIcons} />, name:'Familia',toLink: "/gestion_ventas/familia"},
         {id:'submenu-portafolio-estado-diario',icon:<Icon.BuildingFill style={marginIcons} />, name:'Laboral',toLink: "/gestion_ventas/laboral"},
     ] */

    const SubAdministrador = [
        { id: 'submenu-mantenedor-usuarios', icon: <Icon.Person style={marginIcons} />, name: 'Mantenedor Usuarios', toLink: "/UserPage" },
        { id: 'submenu-mantenedor-roles', icon: <Icon.AppIndicator style={marginIcons} />, name: 'Mantenedor roles', toLink: "/RoleList" },
        { id: 'submenu-mantenedor-servicios', icon: <Icon.Briefcase style={marginIcons} />, name: 'Mantenedor Servicios', toLink: "/ServicesPage" },
        { id: 'submenu-mantenedor-lob', icon: <Icon.Buildings style={marginIcons} />, name: 'Mantenedor Linea de Negocios', toLink: "/LineBusinessPage" },
        { id: 'submenu-mantenedor-lob', icon: <Icon.PersonLock style={marginIcons} />, name: 'Desbloquear Clientes', toLink: "/DesbloqueoPage", authorizedProfiles: [1, 1023] },
    ]

    const ComponentesV2 = [
        {
            id: 'nueva-busqueda.cliente',
            icon: <PersonSearchIcon style={marginIcons} />,
            name: 'Busqueda Cliente',
            toLink: "/home",
            onClick: () => {
                // Reseteo completo al volver a HomePageV2 desde Hoja de Atención o ContratoPage
                //   dispatch(resetTabState());               // Aca se deberia Resetear nuevo tabs
                dispatch(resetAction());                 // Resetea Redux contrato
                sessionStorage.removeItem("customerInterviewId"); // Limpiar sesión
            }
        },
        {
            id: 'nueva-busqueda.contrato',
            icon: <PersonSearchIcon style={marginIcons} />,
            name: 'Busqueda Contrato',
            toLink: "/ContractPageV2",
            onClick: () => {
                // Reseteo completo al volver a HomePageV2 desde Hoja de Atención o ContratoPage
                //   dispatch(resetTabState());               // Aca se deberia Resetear nuevo tabs
                dispatch(resetAction());                 // Resetea Redux contrato
                sessionStorage.removeItem("customerInterviewId"); // Limpiar sesión
            }
        }

    ]

    const _Menu = [
        /*      {id:'menu-inicio',icon:<Icon.HouseDoor />, name:'Gestion Ventas',toLink: "#", subMenu:SubGestionVentas},
             {id:'menu-portafolio',icon:<Icon.Briefcase />, name:'Portafolio', toLink: '#', subMenu:SubMenuPortafolio}, */
        { id: 'menu-generador', icon: <HomeIcon />, name: 'Generador Contrato', tolink: '#', subMenu: SubGeneradorContratos },
        { id: 'menu-perfil-usuario', icon: <AccountBoxIcon />, name: 'Mi Perfil', tolink: '#', subMenu: SubMenuPerfil },
        /*{id:'menu-inicio',icon:<Icon.HouseDoor />, name:'Gestion Ventas',toLink: "#", subMenu:SubGestionVentas},
          {id:'menu-portafolio',icon:<Icon.Briefcase />, name:'Portafolio', toLink: '#', subMenu:SubMenuPortafolio},*/
        { id: 'menu-administrador', icon: <SettingsIcon />, name: 'Administrador', tolink: '#', subMenu: SubAdministrador },
        //{ id: 'menu-componentesV2', icon: <SettingsIcon />, name: 'ComponentesV2', tolink: '#', subMenu: ComponentesV2 },
    ]

    const onClickMenu = (event) => {
        const cookies = new Cookies();

        var exp = cookies.get('expirationTime');
        var expirationTime = null;

        if (typeof exp === "number") {
            expirationTime = exp * 1000;
        } else if (typeof exp === "string") {
            expirationTime = new Date(exp).getTime();
        }

        if (expirationTime) {
            const isExpired = Date.now() >= expirationTime;
            if (isExpired) {
                dispatch(LogoutUser())
                navigate("/")
                return
                // aquí podrías redirigir o eliminar la cookie
            }
        }
        if (cookies.get('identifier') == null) {
            dispatch(LogoutUser())
            navigate("/")
            return
        }
        // FIN expirationTime

        if (event.target.getAttribute("value") == openSubMenu)
            setOpenSubMenu('')
        else
            setOpenSubMenu(event.target.getAttribute("value"))
    }

    const onClickTest = () => {
        const cookies = new Cookies();

        var exp = cookies.get('expirationTime');
        var expirationTime = null;

        if (typeof exp === "number") {
            expirationTime = exp * 1000;
        } else if (typeof exp === "string") {
            expirationTime = new Date(exp).getTime();
        }

        if (expirationTime) {
            const isExpired = Date.now() >= expirationTime;
            if (isExpired) {
                dispatch(LogoutUser())
                navigate("/")
                return
                // aquí podrías redirigir o eliminar la cookie
            }
        }
        if (cookies.get('identifier') == null) {
            dispatch(LogoutUser())
            navigate("/")
            return
        }

        dispatch(resetTabState())
    }

    // Obtener el rolId del usuario actual desde las cookies
    const cookies = new Cookies();
    const userRolId = parseInt(cookies.get('rolId'));

    // Función para filtrar los ítems de submenú según authorizedProfiles
    const filterSubMenu = (subMenu) => {
        return subMenu.filter(item => {
            if (!item.authorizedProfiles) return true;
            return item.authorizedProfiles.includes(userRolId);
        });
    };

    return (
        <Fragment>
            <div className="sidebar py-0" id="sidebar" style={{ maxWidth: '16rem' }}>
                <h6 className="sidebar-heading">Menu </h6>
                <ul className="list-unstyled">
                    {_Menu.map(obj => {
                        return (
                            <li className="sidebar-list-item" key={obj.id}>
                                <NavLink onClick={onClickMenu} value={obj.id} className={({ isActive }) => (isActive ? "sidebar-link text-muted" + (openSubMenu === obj.id ? " bg-primary text-white" : "") : "sidebar-link text-muted")} to={obj.toLink} role="button" >
                                    <span value={obj.id} className="sidebar-link-title">{obj.icon} {obj.name} </span>
                                </NavLink>
                                {(obj.subMenu && openSubMenu === obj.id) ?
                                    <ul className="sidebar-menu list-unstyled" id="dashboardsDropdown" >
                                        {filterSubMenu(obj.subMenu).map(el => {
                                            return (
                                                // <li className="sidebar-list-item" key={el.id} onClick={onClickTest}>
                                                //     <NavLink className={"sidebar-link  text-muted "} to={el.toLink}>{el.icon} {el.name} </NavLink>
                                                // </li>
                                                <li className="sidebar-list-item" key={el.id}>
                                                    <NavLink
                                                        to={el.toLink || '#'}
                                                        className={"sidebar-link text-muted"}
                                                        onClick={(e) => {
                                                            if (!el.toLink) {
                                                                e.preventDefault();
                                                            }
                                                            if (el.onClick) {
                                                                el.onClick();
                                                            }
                                                        }}
                                                    >
                                                        {el.icon} {el.name}
                                                    </NavLink>
                                                </li>

                                            )
                                        })}
                                    </ul> : null}
                            </li>)
                    })}
                </ul>
            </div>
        </Fragment>
    );
}

export default Menu;
